import type { ButtonType } from "@similarweb/ui-components";

export const buttonTypes: { [key: string]: ButtonType } = {
    FLAT: "flat",
    PRIMARY: "primary",
    WARNING: "warning",
    OUTLINED: "outlined",
    UPSELL: "upsell",
    UPSELL_OUTLINE: "upsellOutline",
    FLAT_WARNING: "flatWarning",
    FLAT_DARK: "flatDark",
    FLAT_NEGATIVE: "flatNegative",
    TRIAL_OUTLINE: "trialOutline",
    TRIAL: "trial",
    INVERTED: "inverted",
    COMPARE: "compare",
};

export type ButtonTypeProp =
    | "flat"
    | "primary"
    | "warning"
    | "outlined"
    | "upsell"
    | "upsellOutline"
    | "flatWarning"
    | "flatDark"
    | "flatNegative"
    | "flatTrial"
    | "trialOutline"
    | "trial"
    | "inverted"
    | "compare";
